import { PayableInboxItem } from "@/Billing/Api/Inbox/Dto/Response/BillingInboxItem";
import { SiteUIModel } from "@/Common/Models/Sites/SiteUIModel";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { PayableInboxFilterSettings } from "../Settings/PayableInboxFilterSettings";
import { PayableInboxValidityUIModel } from "./PayableInboxValidityUIModel";

class PayableInboxModel {
    public filterSettings: PayableInboxFilterSettings = new PayableInboxFilterSettings();
    public sums: PayableInboxSums = new PayableInboxSums();
    public data: PayableInboxItem[] = [];

    public availableSites: SiteUIModel[] = [];
    public availableProviders: EmployeeUIModel[] = [];
    public availableBilledBy: EmployeeUIModel[] = [];
    public availableValidity: PayableInboxValidityUIModel[] = [];
    public validationError?: string;
}

class PayableInboxSums {
    constructor(field?: Partial<PayableInboxSums>) {
        Object.assign(this, field);
    }

    public SubtotalSum: number;
    public DiscountSum: number;
    public GSTSum: number;
    public QSTSum: number;
    public HSTSum: number;
    public GenericTaxSum: number;
    public TotalBillSum: number;
}

export { PayableInboxModel, PayableInboxSums };
